import {
    QUICK_SEARCH_QUERY,
    QUICK_SEARCH_RECEIVE,
} from '../constants';

const DEFAULT_STATE = {
    query: '',
    result: []
};

export const quickSearch = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case QUICK_SEARCH_QUERY:
        case QUICK_SEARCH_RECEIVE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
